<template lang="pug">
#lista-laudo-operacao
    BaseHeader(
        :titulo="$t('mensagens.operacao.listaFiscalizacao.titulo')",
        icon='el-icon-download'
        :btnTexto="$t('mensagens.operacao.listaFiscalizacao.exportarDados')",
        :exibeBotao='true',
        @btnHeaderClicado='exportarDados'
    )

    section.lista-laudo-operacao__filtros
        .pesquisa-inteligente__container
            .pesquisa-inteligente__barra-pesquisa
                i.el-icon-search
                input.lista-laudo-operacao__barra-pesquisa__input(
                    v-model='payloadFiltro.textoBusca',
                    type='text',
                    :placeholder='gerarPlaceholderPesquisaInteligente()',
                    autocomplete='off',
                    @keyup.enter='buscarFiscalizacoesOperacoes(0)'
                )

        .filtros-lista-laudo-operacao__button
            el-popover(
                placement='bottom',
                width='500',
                trigger='click',
                @show='aplicarMascaraFitroData'
            )
                BaseButton.button-outline(
                    icon='lyra-icon lyra-filtro',
                    name='filtro',
                    plain,
                    slot='reference'
                ) {{ $t('mensagens.blocoFiltros.uteis.filtrosAvancados') }}

                el-form.filtro(label-position='top')
                    .filtros-lista-laudo-operacao-popover-header
                        .filtros-lista-laudo-operacao-popover-header__text {{ $t('mensagens.blocoFiltros.uteis.filtrosAvancados') }}
                        .filtros-lista-laudo-operacao-popover-header__link(
                            @click='aplicar'
                        )
                            | {{ $t('mensagens.blocoFiltros.uteis.aplicarFiltros') }}

                    .filtros-lista-laudo-operacao-popover-collapse
                        el-form-item.mb-0.filtro-accordion
                            el-collapse(
                                v-model='collapseFiltroAvancado',
                                accordion,
                                @change='abrirCollapse'
                            )
                                el-collapse-item(:title="$t('mensagens.operacao.status')", name='status')
                                    .el-collapse-item__status--loading(
                                        v-loading='!status.length'
                                    )
                                        el-checkbox-group(
                                            :max='1',
                                            v-model='statusSelecionado'
                                        )
                                            el-checkbox(
                                                v-for='(s, index) in status',
                                                :label='s',
                                                :key='index'
                                            )
                                                | {{ $t(`mensagens.operacao.listaFiscalizacao.${s.codigo}`) }}

                                el-collapse-item(
                                    :title="$t('mensagens.operacao.situacao')",
                                    name='situacao'
                                )
                                    .el-collapse-item__situacao--loading(
                                        v-loading='!situacao.length'
                                    )
                                        el-checkbox-group(
                                            :max='1',
                                            v-model='situacaoSelecionada'
                                        )
                                            el-checkbox(
                                                v-for='(s, index) in situacao',
                                                :label='s',
                                                :key='index'
                                            )
                                                | {{ $t(`mensagens.operacao.${s.codigo}`) }}

                                el-collapse-item#filtro-datas(
                                    :title="$t('mensagens.operacao.listaFiscalizacao.datas')",
                                    name='datas'
                                )
                                    el-form-item(:label="$t('mensagens.operacao.listaFiscalizacao.dataSolicitacao')")
                                        el-date-picker(
                                            v-model='dataSolicitacao',
                                            type='daterange',
                                            range-separator='-',
                                            format='dd/MM/yyyy',
                                            :start-placeholder="$t('mensagens.operacao.listaFiscalizacao.dataInicio')",
                                            :end-placeholder="$t('mensagens.operacao.listaFiscalizacao.dataFim')"
                                        )
                                    el-form-item(:label="$t('mensagens.operacao.listaFiscalizacao.previsaoEntrega')")
                                        el-date-picker(
                                            v-model='dataPrevisaoEntrega',
                                            type='daterange',
                                            range-separator='-',
                                            format='dd/MM/yyyy',
                                            :start-placeholder="$t('mensagens.operacao.listaFiscalizacao.dataInicio')",
                                            :end-placeholder="$t('mensagens.operacao.listaFiscalizacao.dataFim')"
                                        )
                                    el-form-item(:label="$t('mensagens.operacao.listaFiscalizacao.dataEntrega')")
                                        el-date-picker(
                                            v-model='dataEntrega',
                                            type='daterange',
                                            range-separator='-',
                                            format='dd/MM/yyyy',
                                            :start-placeholder="$t('mensagens.operacao.listaFiscalizacao.dataInicio')",
                                            :end-placeholder="$t('mensagens.operacao.listaFiscalizacao.dataFim')"
                                        )

    .lista-laudo-operacao__upload-lote__filtros
        section.lista-laudo-operacao__upload-lote__filtros__filtros-tag
            span.lista-laudo-operacao__filtro-selecionado__titulo {{ $t('mensagens.blocoFiltros.uteis.filtrosSelecionados') }}:
            .lista-laudo-operacao__filtro-selecionado__filtros-tag
                el-tag.lista-laudo-operacao__filtro-selecionado__tag(
                    v-for='tag in tags',
                    :key='tag.nome',
                    closable='',
                    type='success',
                    @close='removerFiltro(tag)',
                    style='max-height: 42px'
                )
                    span(v-if='tag.codigo !== "DATA_SOLICITACAO" && tag.codigo !== "DATA_PREVISAO_ENTREGA" && tag.codigo !== "DATA_ENTREGA"' ) {{ $t(`mensagens.operacao.listaFiscalizacao.${tag.codigo}`) }}
                    span(v-else) {{ $t(`mensagens.operacao.listaFiscalizacao.${tag.codigo}`) }} {{ tag.nome }}

            el-tag.lista-laudo-operacao__filtro-selecionado__limpar(
                v-if='tags.length',
                type='info',
                @click='limparFiltros'
            ) {{ $t('mensagens.blocoFiltros.uteis.limparFiltros') }}
                i.el-icon-delete

            span.lista-laudo-operacao__filtro-selecionado__nenhum(v-else) {{ $t('mensagens.blocoFiltros.uteis.nenhumFiltroSelecionado') }}
        BaseButton.mr-3(
            v-if='verificaPerfilAnalista()',
            style='font-weight: bold',
            type='text',
            icon='el-icon-download',
            @click='baixarShapesEmLote()'
        ) {{ $t('mensagens.operacao.listaFiscalizacao.baixarShapeLaudo') }}

        BaseButton.mr-3(
            style='font-weight: bold',
            type='text',
            icon='el-icon-download',
            @click='baixarResultadosEmLote()'
        ) {{ $t('mensagens.operacao.listaFiscalizacao.exportarFiscalizacoesSelecionadas') }}

        BaseButton(
            style='font-weight: bold',
            type='text',
            icon='el-icon-upload2',
            @click='abrirModalUploadLote()'
        ) {{ $t('mensagens.operacao.listaFiscalizacao.uploadSolicitacaoLote') }}

    section.lista-laudo-operacao__selecionar-todas-fiscalizacoes(
        v-if='habilitarSelecionarTodas'
    )
        div(v-if='payloadFiltro.opcao === "SELECAO"')
            span {{ $t('mensagens.operacao.listaFiscalizacao.selecaoTotal', {quantidade_total: totalFiscalizacoesPagina}) }} &nbsp
            a(@click='alternarTipoSelecao') {{ $t('mensagens.operacao.listaFiscalizacao.selecionarTotal', {quantidade_total: totalFiscalizacoesLista}) }}
        div(v-else)
            span {{ $t('mensagens.operacao.listaFiscalizacao.todasFiscalizacoesSelecionadas', {quantidade_total: totalFiscalizacoesLista}) }} &nbsp
            a(@click='alternarTipoSelecao') {{ $t('mensagens.operacao.acoes.limparSelecao') }}

    section.lista-laudo-operacao__tabela
        el-table(
            :data='laudosOperacao',
            stripe,
            height='calc(100% - 54px)',
            :key='tableKey',
            :row-key='getRowKey',
            @selection-change='alterarFiscalizacoesSelecionadas',
            @sort-change='sortChangeRequest',
        )
            el-table-column(
                align='center',
                type='selection',
                :reserve-selection='true'
            )
            el-table-column(
                v-if='verificaPerfilAnalista()',
                :label="$t('mensagens.operacao.listaFiscalizacao.idLaudo')",
                align='center'
            )
                template(slot-scope='scope')
                    span {{ scope.row.id ? scope.row.id : '--' }}

            el-table-column(:label="$t('mensagens.laudos.gridColunaHash')", align='center')
                template(slot-scope='scope')
                    span {{ scope.row.codigo ? scope.row.codigo : '--' }}

            el-table-column(
                v-if='verificaPerfilAnalista()',
                :label="$t('mensagens.operacao.listaFiscalizacao.usuarioSolicitante')",
                align='center'
            )
                template(slot-scope='scope')
                    span {{ scope.row.usuarioSolicitante ? scope.row.usuarioSolicitante : '--' }}

            el-table-column(
                v-if='verificaPerfilAnalista()',
                :label="$t('mensagens.operacao.listaFiscalizacao.analistaResponsavel')",
                align='center'
            )
                template(slot-scope='scope')
                    span {{ scope.row.analista ? scope.row.analista : '--' }}

            el-table-column(
                v-if='verificaPerfilAnalista()',
                :label="$t('mensagens.comuns.empresas')",
                align='center'
            )
                template(slot-scope='scope')
                    span {{ scope.row.empresa ? scope.row.empresa : '--' }}

            el-table-column(:label="$t('mensagens.operacao.tabela.id')", align='center', prop='operacao.identificador', sortable='custom')
                template(slot-scope='scope')
                    span {{ scope.row.identificador ? scope.row.identificador : '--' }}

            el-table-column(:label="$t('mensagens.operacao.listaFiscalizacao.beneficiario')", align='center', prop='representante.nomeRazaoSocial', sortable='custom')
                template(slot-scope='scope')
                    span {{ scope.row.beneficiario ? scope.row.beneficiario : '--' }}

            el-table-column(:label="$t('mensagens.operacao.listaFiscalizacao.dataSolicitacao')", align='center', prop='dataCadastro', sortable='custom')
                template(slot-scope='scope')
                    span {{ scope.row.dataSolicitacao ? scope.row.dataSolicitacao : '--' }}

            el-table-column(:label="$t('mensagens.operacao.listaFiscalizacao.previsaoEntrega')", align='center', prop='dataPrevisaoEntrega', sortable='custom')
                template(slot-scope='scope')
                    span {{ scope.row.dataPrevisaoEntrega ? scope.row.dataPrevisaoEntrega : '--' }}

            el-table-column(:label="$t('mensagens.operacao.listaFiscalizacao.dataEntrega')", align='center', prop='dataFinalizacao', sortable='custom')
                template(slot-scope='scope')
                    span {{ scope.row.dataEntrega ? scope.row.dataEntrega : '--' }}

            el-table-column(:label="$t('mensagens.operacao.situacao')", align='center', prop='situacao.descricao', sortable='custom')
                template(slot-scope='scope')
                    span(:class='["tag", tratarSituacao(scope.row.situacao)]') {{ scope.row.situacao ? $t(`mensagens.operacao.${scope.row.situacaoCodigo}`) : '--' }}

            el-table-column(:label="$t('mensagens.operacao.status')", align='center', prop='status', sortable='custom')
                template(slot-scope='scope')
                    span(:class='["tag", tratarStatus(scope.row.status)]') {{ scope.row.status ? $t(`mensagens.operacao.listaFiscalizacao.${scope.row.statusCodigo}`) : '--' }}

            el-table-column(:label="$t('mensagens.operacao.tabela.acoes')",, width='100', align='center')
                template(slot-scope='scope')
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical.mudando-cursor
                        el-dropdown-menu(slot='dropdown')
                            el-tooltip(
                                v-for='(acao, index) in scope.row.acoesDisponiveis',
                                effect='dark'
                                :content='mensagemTooltip(scope.row)'
                                placement='left',
                                :disabled='!handleDisabled(scope.row, acao)',
                            )
                                div
                                    el-dropdown-item(
                                        :key='index',
                                        :icon='fiscalizacaoOperacaoAcoes[acao].icone',
                                        @click.native='fiscalizacaoOperacaoAcoes[acao].callback(scope.row)',
                                        :disabled='handleDisabled(scope.row, acao)'
                                    ) {{ $t(`mensagens.operacao.acoes.${fiscalizacaoOperacaoAcoes[acao].codigo}`) }}

        .tabela-rodape
            .tabela-rodape--esquerda
                p {{ paginacao.total }} {{ $t("mensagens.operacao.listaFiscalizacao.totalFiscalizacoes") }}

            .tabela-rodape--pagination
                el-pagination(
                    small,
                    layout='prev, pager, next',
                    :page-size='paginacao.itensPorPagina',
                    :current-page.sync='paginacao.pagina',
                    :total='paginacao.total',
                    @current-change='buscarFiscalizacoesOperacoes(paginacao.pagina - 1, true)'
                )

    ModalInsercaoResultado(
        :laudo='laudo',
        :show.sync='mostrarModalResultado',
        @atualizarListagem='buscarFiscalizacoesOperacoes(0)'
    )

    ModalVisualizacao(:show.sync='showModalVisualizacao', :idLaudo='idLaudo')

    ModalCancelamento(
        :show.sync='showModalCancelamento',
        :idLaudo='idLaudo',
        @atualizarListagem='buscarFiscalizacoesOperacoes(0)'
    )

    ModalUploadSolicitacaoLote(
        :show.sync='showModalUploadSolicitacaoLote',
        @atualizar='buscarFiscalizacoesOperacoes(0)'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import ModalInsercaoResultado from '@/views/operacao/fiscalizacao/ModalInsercaoResultado';
import ModalCancelamento from '@/views/operacao/fiscalizacao/ModalCancelamento';
import OperacaoLaudoService from '@/services/OperacaoLaudoService';
import ModalVisualizacao from '@/components/fiscalizacaoOperacao/ModalVisualizacao';
import ModalUploadSolicitacaoLote from '@/components/operacao/fiscalizacao/ModalUploadSolicitacaoLote.vue';
import BaseButton from '@/components/vegaComponents/BaseButton';
import IMask from 'imask';
import { mapState } from 'vuex';

export default {
    name: 'ListaFiscalizacaoOperacoes',
    components: {
        ModalUploadSolicitacaoLote,
        BaseHeader,
        ModalInsercaoResultado,
        ModalVisualizacao,
        ModalCancelamento,
        BaseButton
    },
    data() {
        return {
            showModalVisualizacao: false,
            showModalCancelamento: false,
            showModalUploadSolicitacaoLote: false,
            tableKey: 0,
            fiscalizacoesSelecionadasDownload: [],
            paginasTodasSelecionadas: [],
            habilitarSelecionarTodas: false,
            totalFiscalizacoesLista: 0,
            totalFiscalizacoesPagina: 0,
            laudosOperacao: [],
            tags: [],
            collapseFiltroAvancado: [''],
            status: [],
            situacao: [],
            statusSelecionado: [],
            situacaoSelecionada: [],
            acaoCollapse: {
                status: {
                    collapse: 'status',
                    callback: 'buscarStatus'
                },
                situacao: {
                    collapse: 'situacao',
                    callback: 'buscarSituacao'
                }
            },
            dataSolicitacao: null,
            dataEntrega: null,
            dataPrevisaoEntrega: null,
            payloadFiltro: {
                textoBusca: null,
                filtrosAvancados: {
                    solicitacaoInicio: null,
                    solicitacaoFim: null,
                    entregaInicio: null,
                    entregaFim: null,
                    previsaoEntregaInicio: null,
                    previsaoEntregaFim: null,
                    situacao: [],
                    status: []
                },
                opcao: 'SELECAO',
                paginacao: { pagina: 0, itensPorPagina: 20, direcao: 'ASC', ordernarPor: null}
            },
            paginacao: {
                direcao: null,
                itensPorPagina: 20,
                ordernarPor: null,
                pagina: 0,
                totalPaginas: 0,
                total: 0
            },
            mostrarModalResultado: false,
            idLaudo: null,
            laudo: {},
            fiscalizacaoOperacaoAcoes: {
                BAIXAR_RESULTADO: {
                    nome: this.$t('mensagens.operacao.listaFiscalizacao.baixarResultado'),
                    codigo: 'BAIXAR_RESULTADO',
                    icone: 'el-icon-download',
                    callback: this.baixarResultado
                },
                BAIXAR_SHAPE: {
                    nome: this.$t('mensagens.operacao.listaFiscalizacao.baixarShape'),
                    codigo: 'BAIXAR_SHAPE',
                    icone: 'el-icon-download',
                    callback: this.baixarShape
                },
                ENVIAR_RESULTADO: {
                    nome: this.$t('mensagens.operacao.listaFiscalizacao.enviarResultado'),
                    codigo: 'ENVIAR_RESULTADO',
                    icone: 'el-icon-upload',
                    callback: this.enviarResultado
                },
                VISUALIZAR: {
                    nome: this.$t('mensagens.operacao.acoes.visualizar'),
                    codigo: 'VISUALIZAR',
                    icone: 'el-icon-view',
                    callback: this.visualizarFiscalizacaoOperacao
                },
                CANCELAR: {
                    nome: this.$t('mensagens.operacao.acoes.cancelar'),
                    codigo: 'CANCELAR',
                    icone: 'el-icon-circle-close',
                    callback: this.cancelarFiscalizacaoOperacao
                }
            }
        };
    },
    watch: {
        habilitarSelecionarTodas: function (current) {
            if (current) {
                document.querySelector(
                    '.lista-laudo-operacao__tabela'
                ).style.height = 'calc(100vh - 415px)';
            } else {
                document.querySelector(
                    '.lista-laudo-operacao__tabela'
                ).style.height = 'calc(100vh - 353px)';
            }
        }
    },
    computed: {
        ...mapState(['usuarioLogado'])
    },
    async mounted() {
        this.verificaPerfilAnalista();
        await this.buscarFiscalizacoesOperacoes(0);
    },
    methods: {
        handleDisabled(row, acao) {
            return acao === 'CANCELAR' && ((row.analista !== '--' && !this.usuarioLogado.isAnalyst) || row.situacao === 'Cancelado' || row.situacao === 'Processado');
        },
        mensagemTooltip(row) {
            if (row.situacao === 'Cancelado') {
                return this.$t('mensagens.operacao.listaFiscalizacao.laudoCancelado');
            } else if (row.situacao === 'Processado') {
                return this.$t('mensagens.operacao.listaFiscalizacao.laudoProcessado');
            } else {
                return this.$t('mensagens.operacao.listaFiscalizacao.laudoSendoElaborado');
            }
        },
        aplicarMascaraFitroData() {
            const dataMask = { mask: '00/00/0000' };
            const inputsDatas = document
                .getElementById('filtro-datas')
                .querySelectorAll('input');
            inputsDatas.forEach(item => IMask(item, dataMask));
        },
        abrirModalUploadLote() {
            this.showModalUploadSolicitacaoLote = true;
        },
        async baixarResultadosEmLote() {
            if (
                this.fiscalizacoesSelecionadasDownload.filter(
                    item => item.situacao === 'Processado'
                ).length > 0 || this.payloadFiltro.opcao === 'TODOS'
            ) {
                let body;

                if (this.payloadFiltro.opcao === 'SELECAO') {
                    body = {
                        textoBusca: this.payloadFiltro.textoBusca,
                        filtrosAvancados: this.payloadFiltro.filtrosAvancados,
                        opcao: this.payloadFiltro.opcao,
                        idsLaudos: this.fiscalizacoesSelecionadasDownload
                            .filter(item => item.situacao === 'Processado')
                            .map(item => item.id)
                    };
                } else {
                    body = {
                        textoBusca: this.payloadFiltro.textoBusca,
                        filtrosAvancados: this.payloadFiltro.filtrosAvancados,
                        opcao: this.payloadFiltro.opcao,
                        idsLaudos: null
                    };
                }

                try {
                    await OperacaoLaudoService.downloadResultadoLote(body);

                    this.$notify.success({
                        message: this.$t('mensagens.operacao.notificacao.downloadRealizado')
                    });
                } catch (error) {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.downloadErro')
                    });
                }
            } else {
                this.$notify({
                    type: 'error',
                    dangerouslyUseHTMLString: true,
                    message:
                        this.$t('mensagens.operacao.notificacao.selecionarMinimoUmaFiscalizacaoProcessada')
                });
            }
        },

        async baixarShapesEmLote() {
            if (this.fiscalizacoesSelecionadasDownload.length > 0) {
                let body;

                if (this.payloadFiltro.opcao === 'SELECAO') {
                    body = {
                        textoBusca: this.payloadFiltro.textoBusca,
                        filtrosAvancados: this.payloadFiltro.filtrosAvancados,
                        opcao: this.payloadFiltro.opcao,
                        idsLaudos: this.fiscalizacoesSelecionadasDownload.map(
                            item => item.id
                        )
                    };
                } else {
                    body = {
                        textoBusca: this.payloadFiltro.textoBusca,
                        filtrosAvancados: this.payloadFiltro.filtrosAvancados,
                        opcao: this.payloadFiltro.opcao,
                        idsLaudos: null
                    };
                }

                try {
                    await OperacaoLaudoService.baixarShapeEmLote(body);

                    this.$notify.success({
                        message: this.$t('mensagens.operacao.notificacao.downloadRealizado')
                    });
                } catch (error) {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.downloadErro')
                    });
                }
            } else {
                this.$notify.error(
                    this.$t('mensagens.operacao.notificacao.selecionarMinimoUmaFiscalizacao')
                );
            }
        },

        alternarTipoSelecao() {
            if (this.payloadFiltro.opcao === 'SELECAO') {
                this.payloadFiltro.opcao = 'TODOS';
            } else {
                this.payloadFiltro.opcao = 'SELECAO';
            }
        },
        getRowKey(row) {
            return row.id;
        },
        alterarFiscalizacoesSelecionadas(linhas) {
            const fiscalizacoesSituacaoProcessado = this.laudosOperacao.filter(
                item => item.situacao === 'Processado'
            );

            const todasFiscalizacoesSelecionadas =
                fiscalizacoesSituacaoProcessado.every(item =>
                    linhas.find(aux => aux.id === item.id)
                );

            if (
                todasFiscalizacoesSelecionadas &&
                this.paginacao.total > this.paginacao.itensPorPagina
            ) {
                this.habilitarSelecionarTodas = true;
                this.totalFiscalizacoesPagina =
                    fiscalizacoesSituacaoProcessado.length;

                if (
                    !this.paginasTodasSelecionadas.find(
                        item => item.pagina === this.paginacao.pagina
                    )
                ) {
                    this.paginasTodasSelecionadas.push({
                        pagina: this.paginacao.pagina,
                        quantidadeRegistros: this.totalFiscalizacoesPagina
                    });
                }
            } else {
                this.habilitarSelecionarTodas = false;
                this.payloadFiltro.opcao = 'SELECAO';
            }

            this.fiscalizacoesSelecionadasDownload = linhas;
        },
        fiscalizacaoPodeSerSelecionada(row) {
            return row.situacao === 'Processado';
        },
        gerarPlaceholderPesquisaInteligente() {
            if (this.verificaPerfilAnalista()) {
                return this.$t('mensagens.operacao.listaFiscalizacao.pesquisaInteligente1');
            } else {
                return this.$t('mensagens.operacao.listaFiscalizacao.pesquisaInteligente2');
            }
        },
        verificaPerfilAnalista() {
            return this.$store.state.usuarioLogado.isAnalyst;
        },
        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);

            this.desmarcarFiltroPopover(filtro);

            this.aplicar();
        },
        desmarcarFiltroPopover(filtro) {
            switch (filtro.tipo) {
                case 'DATA_ENTREGA':
                    this.dataEntrega = null;
                    this.payloadFiltro.filtrosAvancados.entregaInicio = null;
                    this.payloadFiltro.filtrosAvancados.entregaFim = null;
                    break;
                case 'DATA_PREVISAO_ENTREGA':
                    this.dataPrevisaoEntrega = null;
                    this.payloadFiltro.filtrosAvancados.previsaoEntregaInicio =
                        null;
                    this.payloadFiltro.filtrosAvancados.previsaoEntregaFim =
                        null;
                    break;
                case 'DATA_SOLICITACAO':
                    this.dataSolicitacao = null;
                    this.payloadFiltro.filtrosAvancados.solicitacaoInicio =
                        null;
                    this.payloadFiltro.filtrosAvancados.solicitacaoFim = null;
                    break;
                case 'STATUS':
                    this.statusSelecionado = [];
                    this.payloadFiltro.filtrosAvancados.status = [];
                    break;
                case 'SITUACAO':
                    this.situacaoSelecionada = [];
                    this.payloadFiltro.filtrosAvancados.situacao = [];
                    break;
            }
        },
        limparFiltros() {
            [...this.tags].forEach(tag => this.removerFiltro(tag));
        },
        aplicar() {
            this.atualizarFiltroAvancado();
            this.tags = [
                ...this.statusSelecionado,
                ...this.situacaoSelecionada
            ];

            if (this.dataEntrega) {
                this.tags.push({
                    id: 1,
                    nome: `${this.$t('mensagens.operacao.listaFiscalizacao.DATA_ENTREGA')} ${this.dataEntrega[0].toLocaleDateString(
                        'pt-BR'
                    )} - ${this.dataEntrega[1].toLocaleDateString('pt-BR')}`,
                    codigo: 'DATA_ENTREGA',
                    tipo: 'DATA_ENTREGA'
                });
            }

            if (this.dataPrevisaoEntrega) {
                this.tags.push({
                    id: 1,
                    nome: `${this.dataPrevisaoEntrega[0].toLocaleDateString(
                        'pt-BR'
                    )} - ${this.dataPrevisaoEntrega[1].toLocaleDateString(
                        'pt-BR'
                    )}`,
                    codigo: 'DATA_PREVISAO_ENTREGA',
                    tipo: 'DATA_PREVISAO_ENTREGA'
                });
            }

            if (this.dataSolicitacao) {
                this.tags.push({
                    id: 1,
                    codigo: 'DATA_SOLICITACAO',
                    nome: `${this.dataSolicitacao[0].toLocaleDateString(
                        'pt-BR'
                    )} - ${this.dataSolicitacao[1].toLocaleDateString(
                        'pt-BR'
                    )}`,
                    tipo: 'DATA_SOLICITACAO'
                });
            }

            this.tags.sort((a, b) => a.nome.localeCompare(b.nome));
            this.buscarFiscalizacoesOperacoes(0);
        },
        atualizarFiltroAvancado() {
            if (this.situacaoSelecionada.length > 0) {
                this.payloadFiltro.filtrosAvancados.situacao = [
                    this.situacaoSelecionada[0].codigo
                ];
            } else {
                this.payloadFiltro.filtrosAvancados.situacao = [];
            }

            if (this.statusSelecionado.length > 0) {
                this.payloadFiltro.filtrosAvancados.status = [
                    this.statusSelecionado[0].codigo
                ];
            } else {
                this.payloadFiltro.filtrosAvancados.status = [];
            }

            if (this.dataEntrega) {
                this.payloadFiltro.filtrosAvancados.entregaInicio =
                    this.dataEntrega[0];
                this.payloadFiltro.filtrosAvancados.entregaFim =
                    this.dataEntrega[1];
            } else {
                this.payloadFiltro.filtrosAvancados.entregaInicio = null;
                this.payloadFiltro.filtrosAvancados.entregaFim = null;
            }

            if (this.dataPrevisaoEntrega) {
                this.payloadFiltro.filtrosAvancados.previsaoEntregaInicio =
                    this.dataPrevisaoEntrega[0];
                this.payloadFiltro.filtrosAvancados.previsaoEntregaFim =
                    this.dataPrevisaoEntrega[1];
            } else {
                this.payloadFiltro.filtrosAvancados.previsaoEntregaInicio =
                    null;
                this.payloadFiltro.filtrosAvancados.previsaoEntregaFim = null;
            }

            if (this.dataSolicitacao) {
                this.payloadFiltro.filtrosAvancados.solicitacaoInicio =
                    this.dataSolicitacao[0];
                this.payloadFiltro.filtrosAvancados.solicitacaoFim =
                    this.dataSolicitacao[1];
            } else {
                this.payloadFiltro.filtrosAvancados.solicitacaoInicio = null;
                this.payloadFiltro.filtrosAvancados.solicitacaoFim = null;
            }
        },

        abrirCollapse(ref) {
            if (ref && ref !== 'datas') {
                try {
                    const acao = this.acaoCollapse[ref];
                    if (!this[ref].length) {
                        this[acao.callback]();
                    }
                } catch (error) {
                    this.exibirNotify(
                        'error',
                        this.$t('mensagens.blocoFiltros.erros.buscarDados')
                    );
                }
            }
        },
        buscarStatus() {
            this.status = [
                { id: 1, nome: this.$t('mensagens.operacao.listaFiscalizacao.CONFORME'), codigo: 'CONFORME', tipo: 'STATUS' },
                {
                    id: 2,
                    nome: this.$t('mensagens.operacao.listaFiscalizacao.INCONFORME'),
                    codigo: 'INCONFORME',
                    tipo: 'STATUS'
                }
            ];
        },
        buscarSituacao() {
            this.situacao = [
                {
                    id: 1,
                    nome: this.$t('mensagens.operacao.PROCESSADO'),
                    codigo: 'PROCESSADO',
                    tipo: 'SITUACAO'
                },
                {
                    id: 2,
                    nome: this.$t('mensagens.operacao.EM_PROCESSAMENTO'),
                    codigo: 'EM_PROCESSAMENTO',
                    tipo: 'SITUACAO'
                },
                {
                    id: 3,
                    nome: this.$t('mensagens.operacao.ATRASADO'),
                    codigo: 'ATRASADO',
                    tipo: 'SITUACAO'
                },
                {
                    id: 4,
                    nome: this.$t('mensagens.operacao.ATRASADO_SOLICITACAO_TARDIA'),
                    codigo: 'ATRASADO_SOLICITACAO_TARDIA',
                    tipo: 'SITUACAO'
                },
                {
                    id: 5,
                    nome: this.$t('constantes.cancelado'),
                    codigo: 'CANCELADO',
                    tipo: 'SITUACAO'
                }
            ];
        },
        exibirNotify(tipo, message) {
            this.$notify[tipo]({
                message
            });
        },
        async buscarFiscalizacoesOperacoes(pagina, mudancaPagina) {
            this.payloadFiltro.paginacao.pagina = pagina;
            this.payloadFiltro.paginacao.itensPorPagina =
                this.paginacao.itensPorPagina;

            await OperacaoLaudoService.buscar(this.payloadFiltro)
                .then(({ data }) => {
                    this.laudosOperacao = data.itens;
                    this.paginacao = data.paginacao;
                    this.paginacao.pagina += 1;

                    this.totalFiscalizacoesLista = data.numProcessados;

                    const fiscalizacoesSituacaoProcessado = data.itens.filter(
                        item => item.situacao === 'Processado'
                    );

                    const todosSelecionadosPaginaAtual =
                        fiscalizacoesSituacaoProcessado.every(item =>
                            this.fiscalizacoesSelecionadasDownload.find(
                                aux => item.id === aux.id
                            )
                        );

                    if (mudancaPagina && todosSelecionadosPaginaAtual) {
                        this.totalFiscalizacoesPagina =
                            fiscalizacoesSituacaoProcessado.length;
                        this.habilitarSelecionarTodas = true;
                    } else {
                        this.habilitarSelecionarTodas = false;
                    }

                    if (mudancaPagina && this.payloadFiltro.opcao === 'TODOS') {
                        this.tableKey += 1;
                        this.habilitarSelecionarTodas = false;
                        this.payloadFiltro.opcao = 'SELECAO';
                        this.fiscalizacoesSelecionadasDownload = [];
                    }

                    data.itens.map(item => {
                        const regexEntre = /\bEntre\b/;
                        const regexA = /\ba\b/;

                        if (regexEntre.test(item.dataPrevisaoEntrega)) {
                            item.dataPrevisaoEntrega = item.dataPrevisaoEntrega.replace(regexEntre, '');
                            item.dataPrevisaoEntrega = item.dataPrevisaoEntrega.replace(regexA, '-');
                        }
                        switch (item.situacao) {
                            case 'Processado':
                                item.situacaoCodigo = 'PROCESSADO';
                                break;
                            case 'Em processamento':
                                item.situacaoCodigo = 'EM_PROCESSAMENTO';
                                break;
                            case 'Atrasado':
                                item.situacaoCodigo = 'ATRASADO';
                                break;
                            case 'Atrasado - solicitação tardia':
                                item.situacaoCodigo = 'ATRASADO_SOLICITACAO_TARDIA';
                                break;
                            case 'Cancelado':
                                item.situacaoCodigo = 'CANCELADO';
                                break;
                            case '--':
                                item.situacaoCodigo = 'STATUS_SITUACAO_VAZIO';
                                break;
                        }
                        switch (item.status) {
                            case 'Conforme':
                                item.statusCodigo = 'CONFORME';
                                break;
                            case 'Inconforme':
                                item.statusCodigo = 'INCONFORME';
                                break;
                            case '--':
                                item.statusCodigo = 'STATUS_SITUACAO_VAZIO';
                                break;
                        }
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.erroBuscaFiscalizacao')
                    });
                });
        },

        async baixarResultado(laudo) {
            try {
                await OperacaoLaudoService.downloadResultado(laudo.id);

                this.$notify.success({
                    message: this.$t('mensagens.operacao.notificacao.downloadRealizado')
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.downloadErro')
                });
            }
        },

        async baixarShape(laudo) {
            try {
                await OperacaoLaudoService.gerarShapeFile(laudo.id);
                await this.buscarFiscalizacoesOperacoes(0);

                this.$notify.success({
                    message: this.$t('mensagens.operacao.notificacao.sucessoExportarArquivo')
                });
            } catch (error) {
                const mensagem =
                    JSON.parse(await error.response.data.text()).message ||
                    this.$t('mensagens.operacao.notificacao.erroExportarArquivo');

                this.$notify.error({
                    message: mensagem
                });
            }
        },

        async exportarDados() {
            try {
                await OperacaoLaudoService.gerarExcel(this.payloadFiltro);

                this.$notify.success({
                    message: this.$t('mensagens.operacao.notificacao.downloadRealizado')
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.downloadErro')
                });
            }
        },

        enviarResultado(laudo) {
            this.laudo = laudo;
            this.mostrarModalResultado = true;
        },

        visualizarFiscalizacaoOperacao(laudo) {
            this.idLaudo = laudo.id;
            this.showModalVisualizacao = true;
        },

        cancelarFiscalizacaoOperacao(laudo) {
            this.idLaudo = laudo.id;
            this.showModalCancelamento = true;
        },

        tratarSituacao(situacao) {
            if (situacao === 'Em processamento') {
                return 'em-processamento';
            } else if (situacao === 'Processado') {
                return 'processado';
            } else if (situacao.startsWith('Atrasado') || situacao === 'Cancelado') {
                return 'atrasado';
            }
            return '';
        },

        tratarStatus(status) {
            if (status) {
                return status.toLowerCase();
            }
            return '';
        },

        sortChangeRequest(column) {
            if (column.order === 'ascending') {
                this.payloadFiltro.paginacao.direcao = 'ASC';
            } else if (column.order === 'descending') {
                this.payloadFiltro.paginacao.direcao = 'DESC';
            }

            this.payloadFiltro.paginacao.ordernarPor = column.column.label;
            this.buscarFiscalizacoesOperacoes(0);
        }
    }
};
</script>

<style scoped lang="scss">
#lista-laudo-operacao {
    height: 100%;
    width: 100%;

    .lista-laudo-operacao__selecionar-todas-fiscalizacoes {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 20px 20px 20px;
        border-radius: 5px;
        height: 42px;
        background-color: var(--secondary);
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        a {
            color: -webkit-link;
            cursor: pointer;

            span {
                color: var(--primary-font-color);
            }
        }
    }

    .lista-laudo-operacao__tabela {
        margin: 0 20px;
        border-radius: 5px;
        height: calc(100vh - 353px);
        background-color: var(--white);
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        .el-table {
            border-radius: 5px;
            height: calc(100% - 54px);
            width: 100%;
        }

        .el-table th {
            font-weight: bold;
            font-size: 14px;
        }

        .tabela-btn {
            margin-top: 14px;
            display: flex;
            justify-content: start;
            align-items: center;
        }

        .tabela-rodape {
            height: 54px;
            background: var(--white);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 44% 10px 5px;
            border-radius: 5px;

            .tabela-rodape--esquerda p {
                margin-bottom: 0;
                color: var(--primary);
                margin-left: 10px;
            }

            .tabela-rodape--pagination {
                .el-pager li.active {
                    color: var(--white);
                    font-weight: 900;
                    background: var(--primary);
                }

                .el-pager li {
                    padding: 0 4px;
                    background: var(--white);
                    vertical-align: top;
                    display: inline-block;
                    font-size: 13px !important;
                    min-width: 28px !important;
                    height: 28px !important;
                    line-height: 28px !important;
                    box-sizing: border-box;
                    text-align: center;
                    margin: 0;
                    border-radius: 2px;
                    color: var(--primary);
                }

                .el-pagination button {
                    height: 28px;
                }
            }
        }
    }

    .lista-laudo-operacao__filtros {
        display: flex;
        justify-content: space-between;
        margin: 20px 20px;

        .pesquisa-inteligente__container {
            width: 100%;
            height: 42px;
            border-radius: 5px;
            background: var(--white);
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            position: relative;
            margin-right: 10px;

            .pesquisa-inteligente__barra-pesquisa {
                height: 100%;
                display: flex;
                justify-content: center;

                i.el-icon-search {
                    color: var(--primary);
                    font-size: 25px;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    margin: 0 8px;
                }

                .lista-laudo-operacao__barra-pesquisa__input {
                    width: 100%;
                    height: 100%;
                    border: none;
                    outline: none;
                    border-radius: 5px;
                    color: var(--primary);
                }
            }
        }
    }
}

.button-outline {
    border-color: var(--primary) !important;
    color: var(--primary) !important;
    background: transparent !important;
    display: flex;
    align-items: center;

    .lyra-filtro:before {
        content: '';
        width: 15px !important;
        height: 12px !important;
        background-color: var(--primary) !important;
        margin-right: 6px;
    }
}

.filtros-lista-laudo-operacao-popover-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    .filtros-lista-laudo-operacao-popover-header__text {
        color: var(--primary);
        font-weight: 600;
    }

    .filtros-lista-laudo-operacao-popover-header__link {
        color: #1989fa;
        text-decoration: underline;
        cursor: pointer;
    }
}

.filtros-lista-laudo-operacao-popover-collapse {
    .el-select {
        width: 100%;
    }

    .el-collapse-item__header {
        font-weight: 500;
    }

    .filtro-accordion {
        margin-top: 10px;
    }

    .el-checkbox,
    .el-radio {
        margin-right: 12px !important;
        min-width: 200px;
        line-height: 2;
    }

    .el-checkbox-group,
    .el-radio-group {
        display: flex;
        flex-wrap: wrap;
    }
}

.filtros-lista-laudo-operacao-popover-collapse__select {
    display: flex;
    justify-content: space-between;
}

.filtros-lista-laudo-operacao-popover-collapse {
    .el-select {
        width: 100%;
    }

    .el-collapse-item__header {
        font-weight: 500;
    }

    .filtro-accordion {
        margin-top: 10px;
    }

    .el-checkbox,
    .el-radio {
        margin-right: 12px !important;
        min-width: 200px;
        line-height: 2;
    }

    .el-checkbox-group,
    .el-radio-group {
        display: flex;
        flex-wrap: wrap;
    }
}

.el-collapse-item__status--loading {
    min-height: 30px;
}

.el-collapse-item__situacao--loading {
    min-height: 30px;
}

.filtros-lista-laudo-operacao-popover-collapse__select {
    display: flex;
    justify-content: space-between;
}

.lista-laudo-operacao__upload-lote__filtros {
    margin: 0 20px 10px;
    min-height: 42px;
    max-height: 42px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .lista-laudo-operacao__upload-lote__filtros__filtros-tag {
        width: calc(100% - 142px);
        overflow: auto;
        display: flex;
    }

    .lista-laudo-operacao__filtro-selecionado__filtros-tag {
        overflow: auto;
        max-width: calc(100% - 300px);
        max-height: 42px;
    }

    .lista-laudo-operacao__filtro-selecionado__tag {
        margin: 0 5px 5px 5px;
    }

    .lista-laudo-operacao__filtro-selecionado__titulo {
        font-size: 16px;
        font-weight: 400;
        margin-right: 10px;
        width: 150px;
        display: flex;
        align-items: center;
    }

    .lista-laudo-operacao__filtro-selecionado__limpar {
        cursor: pointer;
        margin: 0 5px 0 5px;

        i {
            padding-left: 5px;
        }
    }

    .lista-laudo-operacao__filtro-selecionado__nenhum {
        margin-left: 5px;
        font-weight: 100;
        font-style: italic;
        font-size: 14px;
    }
}

.lista-laudo-operacao__upload-lote {
    margin-right: 20px;
    min-height: 42px;
    max-height: 42px;
}

.mudando-cursor {
    cursor: pointer;
}

.tag {
    border-radius: 5px;
    text-align: center;
    font-size: 11px;
    font-weight: 500;
    padding: 3px;
}

.processado {
    border: 1px solid var(--tag-success-border);
    background-color: var(--tag-success-background);
    color: var(--tag-success-text);
}

.em-processamento {
    border: 1px solid var(--tag-warning-border);
    background-color: var(--tag-warning-background);
    color: var(--tag-warning-text);
}

.atrasado {
    border: 1px solid var(--tag-danger-border);
    background-color: var(--tag-danger-background);
    color: var(--tag-danger-text);
}

.conforme {
    border: 1px solid var(--tag-success-border);
    background-color: var(--tag-success-background);
    color: var(--tag-success-text);
}

.inconforme {
    border: 1px solid var(--tag-danger-border);
    background-color: var(--tag-danger-background);
    color: var(--tag-danger-text);
}
</style>
